export interface Package {
  slug: string;
  key: string;
  name: string;
  priceBandKey: string;
  timelineKey: string;
  featured: boolean;
  tags: readonly string[];
}

export const PACKAGES: readonly Package[] = [
  {
    slug: "ai-mvp",
    key: "aiMvp",
    name: "AI MVP in 4 weeks",
    priceBandKey: "aiMvp",
    timelineKey: "aiMvp",
    featured: true,
    tags: ["Fixed scope", "AI-powered", "Production-ready"],
  },
  {
    slug: "automation-audit",
    key: "automationAudit",
    name: "Agent Automation Audit",
    priceBandKey: "automationAudit",
    timelineKey: "automationAudit",
    featured: false,
    tags: ["~1 week", "ROI estimate", "Roadmap"],
  },
  {
    slug: "conversion-teardown",
    key: "conversionTeardown",
    name: "Conversion Teardown",
    priceBandKey: "conversionTeardown",
    timelineKey: "conversionTeardown",
    featured: false,
    tags: ["Fixed fee", "Audit", "Prioritized fixes"],
  },
] as const;

export function findPackageBySlug(slug: string): Package | undefined {
  return PACKAGES.find((p) => p.slug === slug);
}
